import { useState } from "react";
import { Box } from "@mui/material";
import UiSideModal from "components/base/UiSideModal";
import UiButton from "components/base/UiButton";
import { CostRow, Worksheet } from "./calculator";
import WorksheetMaterialQuantity, { materialQuantityPreview } from "./WorksheetMaterialQuantity";

export default function WorksheetMaterialCalculationDrawer({
  item,
  row,
  onApply,
  onClose,
  readOnly,
  busy,
  settings,
}: {
  item: Worksheet;
  row: CostRow;
  onApply: (row: CostRow) => void;
  onClose: () => void;
  readOnly: boolean;
  busy: boolean;
  settings: any;
}) {
  const [draft, setDraft] = useState(row);
  return (
    <UiSideModal open onClose={onClose} title="Material Quantity Calculation" width="598px">
      <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}>
        <WorksheetMaterialQuantity
          item={item}
          row={draft}
          onChange={(patch) => setDraft((current) => ({ ...current, ...patch }))}
          readOnly={readOnly}
          busy={busy}
          settings={settings}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <UiButton uiVariant="outlined-small" onClick={onClose}>
            {readOnly ? "Close" : "Cancel"}
          </UiButton>
          {!readOnly && (
            <UiButton
              uiVariant="primary-green"
              disabled={busy || !!materialQuantityPreview(item, draft).error}
              onClick={() => {
                onApply(draft);
                onClose();
              }}
            >
              Apply
            </UiButton>
          )}
        </Box>
      </Box>
    </UiSideModal>
  );
}
